import { BOOKING_CONTEXT_WARNING_POPUP_KEY } from '../../app/screens/Visits/EnrollVisit/ConsentConfirmationModal';

export const DISABLED_A_CODE_REMINDER_PROVIDERS = 'disabledACodeReminders';
export const ALREADY_OPENED_STORAGE_KEY = 'providerCheck';
const PASTVISITS_KEY = 'data_p';
const FUTURE_VISITS_KEY = 'data_a';
const FB_SYNC_KEY = 'docs';
const FAVORITES_KEY = 'data_f';

const VERBATIM_KEYS = {
    deviceId: 1,
    ums: 1,
    clinics: 1,
    physicians: 1,
    db_version: 1,
    selections: 1,
    firebase_ts: 1,
    bumbaBanner: 1,
    profileList: 1,
    hide_visit_provider: 1,
    remove_visit_provider: 1,
    remove_visit_date: 1,
    hide_visit_date: 1,
    tests: 1,
    disableOfflineClinicWarning: 1,
    [DISABLED_A_CODE_REMINDER_PROVIDERS]: 1,
    [ALREADY_OPENED_STORAGE_KEY]: 1,
    [PASTVISITS_KEY]: 1,
    [FUTURE_VISITS_KEY]: 1,
    [FB_SYNC_KEY]: 1,
    [FAVORITES_KEY]: 1,
    syncedVersion: 1,
    authVersion: 1,
    [BOOKING_CONTEXT_WARNING_POPUP_KEY]: 1,
};

const VERBATIM_ENDS_KEYS = [ 'lastBackupError', 'lastRestoreError' ];
const resolveStorage = (key) => (VERBATIM_KEYS[key] || VERBATIM_ENDS_KEYS?.find(name => key?.endsWith(name)) || !window.isDesktop ? window.localStorage : window.sessionStorage);

function normHeaders(s = '') {
    return s
        .split('\n')
        .filter(Boolean)
        .reduce((r, h) => {
            const [ k, v = '' ] = h.split(':');
            const nkey = k
                .trim()
                .split('-')
                .map((s) => s[0].toUpperCase() + s.slice(1))
                .join('-');
            r[nkey] = v.trim();
            return r;
        }, {});
}

const fileKey = (file) => file.split('/')
    .slice(-1)[0];
export default {
    fs: {
        dirs: {
            DocumentDir: '',
        },
        readFile: (file, encoding) => {
            const key = fileKey(file);
            const storage = resolveStorage(key);
            return storage.getItem(key);
        },
        writeFile: (file, s, encoding) => {
            const key = fileKey(file);
            const storage = resolveStorage(key);
            return storage.setItem(key, s);
        },
        unlink: (file) => {
            const key = fileKey(file);
            const storage = resolveStorage(key);
            return storage.removeItem(key);
        },
        exists: (file) => {
            const key = fileKey(file);
            const storage = resolveStorage(key);
            for (let i = 0; i < storage.length; i++) {
                if (key === storage.key(i)) {
                    return Promise.resolve(true);
                }
            }
            return Promise.resolve(false);
        },
        ls: () => {
            const r = [];
            const storage = resolveStorage('');
            for (let i = 0; i < storage.length; i++) {
                r.push(storage.key(i));
            }
            return Promise.resolve(r);
        },
    },
    config: () => ({
        fetch: (method, url, headers, body, responseType) =>
            new Promise((resolve, reject) => {
                let http = new XMLHttpRequest();
                http.open(method, url, true);
                Object.entries(headers || {})
                    .forEach(([ key, val ]) => http.setRequestHeader(key, val));
                http.withCredentials = true;
                if (responseType) {
                    http.responseType = responseType;
                }
                http.onreadystatechange = () => {
                    if (http.readyState === 4) {
                        const data = responseType === 'blob' ? http.response : http.responseText;
                        const headers = normHeaders(http.getAllResponseHeaders());
                        const respInfo = {
                            status: http.status,
                            headers,
                            body: data,
                            code: http.statusText,
                        };
                        resolve({
                            respInfo,
                            info: () => respInfo,
                            data,
                            json: () => JSON.parse(data),
                        });
                    }
                };
                http.send(body);
            }),
    }),
};
